import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen p-8" }
const _hoisted_2 = { class: "flex-grow" }

import UsersTable from '@/components/users/UsersTable.vue';
import { useStore } from 'vuex';
import { computed, onMounted, watch } from 'vue';
import TableHeader from '@/components/common/TableHeader.vue';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const users = computed(() => store.getters['users/usersData']);

const searchTerm = computed(() => {
  const queryParam = route.query.search;
  return Array.isArray(queryParam) ? queryParam[0] || '' : queryParam || '';
});

const filteredUsers = computed(() => {
  const searchValue = searchTerm.value || '';
  return searchValue
    ? users.value.filter((user: {name: string}) => user.name.toLowerCase().includes(searchValue.toLowerCase()))
    : users.value;
});


const handleSearch = (query: string) => {
  store.dispatch('users/setSearchTerm', query);
  router.push({ query: query ? { search: query } : {} });
};

watch(() => route.query.search, (newQuery) => {
  store.dispatch('users/setSearchTerm', newQuery || '');
});

onMounted(() => {
  store.dispatch('users/fetchUsers');
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(TableHeader, {
      title: "SWAPI Dashboard",
      placeholder: "Search by name...",
      searchTerm: searchTerm.value,
      "onUpdate:search": handleSearch
    }, null, 8, ["searchTerm"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(UsersTable, { users: filteredUsers.value }, null, 8, ["users"])
    ])
  ]))
}
}

})